import { Component } from '@angular/core';
import { VaBasePricingComponent } from '../base-pricing.component';

@Component({
  selector: 'store-highlight-pricing',
  templateUrl: './highlight-pricing.component.html',
  styleUrls: ['./highlight-pricing.component.scss'],
  standalone: false,
})
export class HighlightPricingComponent extends VaBasePricingComponent {}
